import {
  Paper,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import MenuUsageChart from "../chart/MenuUsageChart";

export default function AccessMainPanel({data}) {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, height: 500 }}>
          <Typography variant="body2" color="text.secondary" sx={{height : "30px", fontSize:"20px", marginTop:"5px"}}>
            {t('message.common.subtitle.activity.menuStatistics')}
          </Typography>

          <MenuUsageChart data={data} />

        </Paper>
      </Grid>

    </Grid>
  );
}